const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/,
  ),
);

export function register() {
  if (
    process.env.NODE_ENV !== "production" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      // On localhost, check if a service worker still exists
      checkValidServiceWorker(swUrl);
    } else {
      registerValidSW(swUrl);
    }
  });
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log("[SW] Registered successfully");

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // New content available - show update prompt
              showUpdateNotification(registration);
            } else {
              console.log("[SW] Content cached for offline use");
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("[SW] Registration failed:", error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType && !contentType.includes("javascript"))
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister();
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log("[SW] No internet connection. Running in offline mode.");
    });
}

function showUpdateNotification(registration) {
  // Create a small toast-style notification
  const toast = document.createElement("div");
  toast.setAttribute(
    "style",
    [
      "position:fixed",
      "bottom:24px",
      "left:50%",
      "transform:translateX(-50%)",
      "background:#111",
      "border:1px solid rgba(var(--accent-rgb), 0.25)",
      "color:#fff",
      "padding:14px 24px",
      "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif",
      "font-size:0.85rem",
      "z-index:999999",
      "display:flex",
      "align-items:center",
      "gap:16px",
      "cursor:pointer",
      "max-width:90vw",
    ].join(";"),
  );
  toast.innerHTML =
    '<span>New version available</span><span style="color:var(--accent);font-weight:700;font-size:0.78rem;letter-spacing:0.5px;text-transform:uppercase;white-space:nowrap">Update</span>';

  toast.addEventListener("click", () => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
    window.location.reload();
  });

  document.body.appendChild(toast);
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
